import GetPetSub from '@api/routes/myvca-api/get-pet-subscriptions';

var VCA = VCA || {};

VCA.ManageSubscriptionList = (function ($) {

    var ui = {};

    function cacheUI() {
        ui.$petSelector = $('[data-control="petselector"]');
        ui.$listContainer = $('[data-region="sublist"]');
        ui.loader = $('.ajax-loader');
    }

    function init() {
        if ($('.subscription-list__cards-wrapper').length <= 0) {
            return;
        }
        cacheUI();
        bindPetSelector();
    }

    function bindPetSelector() {
        ui.$petSelector.on('change', function (e) {
            e.preventDefault();
            ui.loader.show();
            ui.$listContainer.addClass('loading');
           let petId = ui.$petSelector.val();
           let petName = ui.$petSelector.children("option").filter(":selected").text();
           getPetResults(petId, petName);
          
        });
    }

    async function getPetResults(petId, petName) {
        let params = {
            "petId":petId
        }
        const { success, data, error } = await GetPetSub.query(params);
        //console.log('data', data);
        if (!success || !data) {
            console.log('failed', error);
            ui.loader.hide();
            ui.$listContainer.removeClass('loading');
            return;
        }
        else if(data === null || data.length === 0) {
            let noResuts = `
            <div class="bg-color-vca-sky-tint-2 subscription-list__empty-state w-100">
                <div class="subscription-list__empty-state__desc">You currently have no Subscriptions for ${petName}</div>
            </div>`
            ui.$listContainer.html(noResuts);
            ui.loader.hide();
            ui.$listContainer.removeClass('loading');
            return;
        }
        else {
            createCard(data);
        }
    }

    function createCard(subItem) {
        ui.$listContainer.html('');

        for (var a = 0; a < subItem.length; a++) {
            var cardContainer = $(document.createElement('div')).addClass('subscription-list__card');



            var innerCard = $(`
                    <a href="${subItem[a].IdUrl}" class="subscription-list__subscription-image">
                        <img src="${subItem[a].ProductImage}" alt="${subItem[a].ProductImageAlt}">
                    </a>
                    <div class="subscription-list__info-wrapper">
                        <a href="${subItem[a].IdUrl}" class="subscription-list__presc-title">${subItem[a].ProductName}</a>
                        <div class="subscription-list__middle">${subItem[a].Brand}</div>
                        <div class="subscription-list__lower">
                            <img class="pet-profile-img" src="/-/media/2/project/common/no_img_pet.ashx" data-petid="${subItem[a].PetId}" alt="Pet Image Icon" title="${subItem[a].PetName}">
                            <div class="pet-name">${subItem[a].PetName}</div>
                        </div>
                    </div>
                    <div class="subscription-list__details-btn-wrapper">
                        <a href="${subItem[a].IdUrl}" class="">
                            <span class="sr-only">view details</span>
                            <i class="far fa-chevron-right"></i>
                        </a>
                    </div>
            `);

            cardContainer.append(innerCard);
            ui.$listContainer.append(cardContainer);
            ui.loader.hide();
            ui.$listContainer.removeClass('loading');
        }

    }

 

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.ManageSubscriptionList.init();
});


